
//ui-全局变量
export const table1 = 'calc(100vh - 210px)' //带搜索条件的
export const table2 = 'calc(100vh - 245px)'  //不带搜索条件，只有一个按钮
export const table3 = 'calc(100vh - 340px)'  //操作框里的，带搜索条件的
export const table4 = 'calc(100vh - 340px)'  
export const table5 = 'calc(100vh - 170px)'   //不带搜索框和按钮只有一个表格
export const table6 = 'calc(100vh - 260px)'   //
export const table7 = 'calc(100vh - 295px)'   //操作框里的，带form表单搜索条件的
export const table8 = 'calc(100vh - 256px)' //带搜索条件的

